// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderSkeleton_container__2rf4R","leftOffset":"LoaderSkeleton_leftOffset__HiupB","row":"LoaderSkeleton_row__1AlL1","img":"LoaderSkeleton_img__jF5iV"};